
import { throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ConfigService } from './config.service';
import { saveAs } from 'file-saver';

@Injectable()
export class StationDetailsService {
	baseDataDir: string;

	constructor (private http: HttpClient, private configService: ConfigService) {
		this.baseDataDir = this.configService.baseDataDir;
	}

	// Calls configService.createURI using the options specified to create a data web services url.
	// Runs http.get to retrieve the created path.
	// If options.format is set to csv, text is the expected response type;
	// otherwise json is the expected response type.
	// If other format types are added to the possible return values, this function must be modified.
	getStationDetails(options): Observable<any> {
		const fullPath = this.configService.createURI(options);
		if ( options.hasOwnProperty('format') && options.format === 'csv') {
			return this.http.get(fullPath, {responseType: 'text'});
		} else {
			return this.http.get(fullPath);
		}
	}

	// downloadData of time series displayed on the current dashboard
	// Using the stationTSArray, creates an array specifying the information needed to download individual time series
	// using data web services.  An accompanying array which contains the time series identifier strings is also created and
	// passed to stationDetailsService.downloadAsSingleFiles.
	// http://44.233.133.104/novastar/data/api/v1/ts?stationNumId=110&dataType=Precip&dataInterval=IrregSecond&timezone=America/Denver&format=JSON
	// ( actually, at this point, timezone information is not included )
	downloadData ( format, stationID, stationTSArray, periodOfRecordSelected, startDate, endDate ) {
		console.log ('In downloadData');
		const dataOptionsArray = [];
		const fullTSIdArray = [];
		const id = stationID;
		console.log(stationTSArray.length);

		for ( let i = 0; i < stationTSArray.length; i++ ) {
			for ( let j = 0; j < stationTSArray[i].data.length; j++ ) {
				const currentTSElement = stationTSArray[i].data[j];
				const tsArray = currentTSElement.ts;
				for ( let k = 0; k < tsArray.length; k++ ) {
					const ts = tsArray[k];
					if ( ts != null ) {
						const dataType = ts.dataType;
						const interval = ts.dataInterval;
						const locId = ts.locId;

						// Files will be named <locId/id>.<dataType>.<dataInterval>
						const identifier = ( locId != '' && locId != null ) ? locId : id;
						const fullTSId = identifier + '.' + dataType + '.' + interval;
						// console.log(fullTSId, locId, dataType, interval );
						const dataOptions = {
							'filename': 'ts',
							'id': id,
							'locId': locId,
							'dataType': dataType,
							'dataInterval': interval,
							'format': format
						};

						if ( periodOfRecordSelected != '0' ) {
							dataOptions['duration'] = periodOfRecordSelected;
						} else {
							dataOptions['periodStart'] = startDate;
							dataOptions['periodEnd'] = endDate;
						}

						dataOptionsArray.push ( dataOptions );
						fullTSIdArray.push ( fullTSId );

						// if this is a windSpeed time series, check for existance of windDirection
						if ( ts.dataType === 'WindSpeed') {
							// shallow copy dataOptions
							let dataOptionsCopy = { ... dataOptions };
							dataOptionsCopy.dataType = 'WindDir';
							dataOptionsArray.push ( dataOptionsCopy );
							fullTSIdArray.push ( identifier + '.WindDir.' + interval );
						}
					}
				}
			}
		}

		this.downloadAsSingleFiles(dataOptionsArray, fullTSIdArray );
	}

	// Loop through dataOptionsArray and download each TS into an individual file, named for the fullTSIdArray contents.
	// dataOptionsArray and fullTSIdArray should have matching lengths
	// dataOptionsArray - an array of options to pass to dataWebServiceService.getWSData which includes
	// 		the desired service, the id, dataType, period start and ends dates, etc.
	// fullTSIdArray - this array contains the fullTSId, which mirror the dataOptionsArray
	async downloadAsSingleFiles(dataOptionsArray, fullTSIdArray ) {
		if ( dataOptionsArray.length === 0 ) {
			console.log('No time series submitted to download.')
			return;
		}
		// assuming all requests are for the same output format
		const filenameExtension = dataOptionsArray[0].format;
		const format = dataOptionsArray[0].format;

		for ( let i = 0; i < dataOptionsArray.length; i++ ) {
			this.getStationDetails( dataOptionsArray[i])
				.subscribe ( async ts => {
					// console.log(ts);  // comment this eventually
					const blob = ts;
					if ( format === 'csv' && !blob.includes('\n')) {  // this isn't working
						console.log('No data in ' + fullTSIdArray[i]);
					} else if ( format === 'json' && ( blob.ts.length === 0 || blob.ts.data.length === 0 )) {
						console.log('No data in ' + fullTSIdArray[i]);
					} else {
						// Data exists!  Turn data into a Blob and download.
						const blobTS = format === 'csv' ?
							new Blob([blob], {type: 'text/csv;charset=utf-8'}) :  // setting type here is crucial.
							new Blob([JSON.stringify(blob)], {type: 'blob' as 'json'});  // setting type here is crucial.
						saveAs ( blobTS, fullTSIdArray[i] + '.' + filenameExtension);
					}

				},
				error => {
					console.log(error);
				});
		}
	}

	private handleError (error: any) {
		const errMsg = (error.message) ? error.message :
			error.status ? `${error.status} - ${error.statusText}` : 'Server error';
		console.error(errMsg); // log to console instead
		return observableThrowError(errMsg);
	}
}
